import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';
import { ErrorNotficationComponent } from '../error-notfication/error-notfication.component';

@Component({
  selector: 'app-reject-success',
  standalone: true,
  imports: [MatDialogModule,CommonModule,ErrorNotficationComponent],
  templateUrl: './reject-success.component.html',
  styleUrl: './reject-success.component.scss'
})
export class RejectSuccessComponent {
  message: string = ""
  title:string=""
  action:string=""
  actionType: string="add"
  cancelButtonText = "Cancel"
  cssClass = ""
  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<ErrorNotficationComponent>) {
    if (data) {
      this.message = data.message;
      this.title= data.title;
      this.action = data.actionType
      this.cssClass = data.cssClass
     
    }
    this.dialogRef.updateSize('300vw','300vw')
  }

  onConfirmClick(): void {
    this.dialogRef.close(true);
  }

}
